module.exports = __webpack_public_path__ + "static/media/focus-sub-01.42ae67ce.jpg";